import { Component } from 'react';
import cx from 'classnames';
import Button from '../ui/button';
import Anchor from '../ui/Anchor';
import { CDN_CLRSAVE_URL } from '../../constants';
import { Router } from '../../configs/routes';
import styles from '../../styles/common/compareFundWidget.scss';
import { handleTrack } from '../../utils/trackActions';

interface State {
  showWidget: boolean;
}

interface Props {
  totalFunds: number;
  fundList: any[];
  isDuplicate: boolean;
  isMaxReached: boolean;
  deleteFund: (id: number) => void;
  deleteAll: (e: any) => void;
}

interface FundProps {
  fundName: string;
  imageUrl: string;
  productId: number;
  deleteFund: () => {};
}

class CompareFundWidget extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showWidget: false,
    };
  }

  private toggleWidget = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        showWidget: !prevState.showWidget,
      };
    });
  };

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { totalFunds } = nextProps;
    if (
      this.state.showWidget &&
      !totalFunds &&
      totalFunds !== this.props.totalFunds
    ) {
      setTimeout(() => {
        this.setState({
          showWidget: false,
        });
      }, 2000);
    }
  }

  private navigateToCompare = (e: any) => {
    const isins = this.props.fundList.map(fund => fund.isinCode);
    const path = `/save/compare-funds?isinCodes=${isins.join(',')}`;
    handleTrack({
      label: `top_funds_button_popup_widget_${e.target.textContent}_${isins}`,
      url: path,
    });
    Router.pushRoute(path, path, { shallow: true });
  };

  private getAlert() {
    const { isDuplicate, isMaxReached } = this.props;
    let message = '';
    if (isDuplicate) {
      message = 'The fund is already added';
    } else if (isMaxReached) {
      message = 'Can not add more than 4 funds, to add more click on Continue';
    }
    return message;
  }

  public render() {
    const { showWidget } = this.state;
    const { totalFunds, fundList, deleteFund, deleteAll } = this.props;
    const message = this.getAlert();

    if (totalFunds && !showWidget && !message) {
      return (
        <div className={styles['compare-fund-widget-trigger']}>
          <Button
            showBadge
            count={totalFunds}
            badgeStyles={styles.badge}
            label="Compare"
            onClick={this.toggleWidget}
            className={cx(
              's-btn text--uppercase',
              styles['compare-widget-btn']
            )}
          />
        </div>
      );
    }
    if (showWidget || message) {
      return (
        <div className={styles['compare-fund-widget']}>
          <div className="row pt10 ml0 mr0">
            <span
              className={cx('font--red mb20 text--md text-center', {
                block: message.length,
              })}
            >
              {message}
            </span>
          </div>
          <span
            onClick={this.toggleWidget}
            className={styles['close-widget']}
          />
          <div className={cx('row ml0 mr0', styles['fund-container'])}>
            {fundList.map(fund => (
              <FundInfo
                key={fund.productId}
                deleteFund={() => deleteFund(fund.productId)}
                {...fund}
              />
            ))}
            {!fundList.length ? (
              <span className="font--grey pb20 block text-center">
                No funds to show
              </span>
            ) : null}
          </div>
          <div className="columns text-right p0">
            <Anchor
              name="Remove All"
              onClick={deleteAll}
              className="font--orange text--uppercase mr15 font--bold desktop-only"
            />
            <Button
              showBadge
              count={totalFunds}
              badgeStyles={styles.badge}
              label="Continue"
              onClick={this.navigateToCompare}
              className={cx(
                's-btn s-btn--orange  text--uppercase',
                styles['compare-widget-btn']
              )}
            />
          </div>
        </div>
      );
    }
    return null;
  }
}

export default CompareFundWidget;

const FundInfo = ({ fundName, imageUrl, deleteFund }: FundProps) => (
  <div className={cx('inline-block mb10', styles.fund)}>
    <figure>
      <img
        width="30"
        height="30"
        src={`${CDN_CLRSAVE_URL}/clearsave${imageUrl}`}
        alt={fundName}
      />
      <img
        src={`${CDN_CLRSAVE_URL}/ct-frontend/images/delete.svg`}
        className="float--right cursor--pointer"
        alt="delete"
        onClick={deleteFund}
        width="12"
        height="12"
      />
    </figure>
    <figure className="cursor--pointer" />
    <label className="text--sm">{fundName}</label>
  </div>
);



// WEBPACK FOOTER //
// ./components/common/compareFundWidget.tsx